var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * PersonCircle component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconPersonCircle extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.60547 12C2.60547 6.81127 6.81175 2.60498 12.0005 2.60498C17.1892 2.60498 21.3955 6.81127 21.3955 12C21.3955 14.5216 20.402 16.8112 18.7852 18.4987C18.0829 17.5839 17.2007 16.8179 16.1896 16.2499C14.9103 15.5313 13.4676 15.1538 12.0003 15.1538C10.5329 15.1538 9.09028 15.5313 7.81097 16.2499C6.79996 16.8178 5.91785 17.5838 5.21552 18.4985C3.59881 16.811 2.60547 14.5215 2.60547 12ZM6.33972 19.4988C7.91397 20.689 9.87478 21.395 12.0005 21.395C14.1261 21.395 16.0868 20.6891 17.661 19.4989C17.0715 18.7061 16.3205 18.0439 15.455 17.5577C14.4 16.9651 13.2103 16.6538 12.0003 16.6538C10.7903 16.6538 9.60058 16.9651 8.5456 17.5577C7.68011 18.0439 6.92916 18.706 6.33972 19.4988ZM12.0005 1.10498C5.98333 1.10498 1.10547 5.98284 1.10547 12C1.10547 18.0171 5.98333 22.895 12.0005 22.895C18.0176 22.895 22.8955 18.0171 22.8955 12C22.8955 5.98284 18.0176 1.10498 12.0005 1.10498ZM12.0006 6.50732C10.2598 6.50732 8.84863 7.91849 8.84863 9.65925C8.84863 11.4 10.2598 12.8112 12.0006 12.8112C13.7413 12.8112 15.1525 11.4 15.1525 9.65925C15.1525 7.91849 13.7413 6.50732 12.0006 6.50732ZM7.34863 9.65925C7.34863 7.09006 9.43137 5.00732 12.0006 5.00732C14.5697 5.00732 16.6525 7.09006 16.6525 9.65925C16.6525 12.2284 14.5697 14.3112 12.0006 14.3112C9.43137 14.3112 7.34863 12.2284 7.34863 9.65925Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconPersonCircle.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconPersonCircle.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconPersonCircle.prototype, "size", void 0);
if (customElements.get('cat-icon-person-circle') === undefined) {
    customElements.define('cat-icon-person-circle', BlocksIconPersonCircle);
}
